exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper .swiper-pagination[data-v-0f66c719] {\n  padding: 10px 0;\n  position: relative;\n  background: #f7f7f7;\n  bottom: 0;\n}\n.swiper .swiper-pagination .swiper-pagination-bullet[data-v-0f66c719] {\n  background: black;\n  opacity: 0.1;\n}\n.swiper .swiper-pagination .swiper-pagination-bullet-active[data-v-0f66c719] {\n  opacity: 1;\n}", ""]);

// exports
